import Box from '@mui/material/Box'
import ViewSelector from './ViewSelector/ViewSelector'
import { useDispatch, useSelector } from 'react-redux'
import SelectorStudentClass from './SelectorStudentClass/SelectorStudentClass'
import { useEffect } from 'react'
import { updateFieldValue } from '../../../../../../store/actions/analytics.actions'
import ByStudent from './ByStudent/ByStudent'
import ByClasses from './ByClasses/ByClasses'
import MarkignLegend from './MarkingLegend/MarkignLegend'
import Module from '../../../../../layout/Module'
import LoadingSpinner from '../../../../../Loading/LoadingSpinner'
import { useLocation, useParams } from 'react-router-dom'
import { useCallback } from 'react'
import useFetchData from '../../../../../../hooks/useFetchData'
import isEmpty from 'lodash/isEmpty'

const Current = ({ isLoading }) => {
  const roles = useSelector((state) => state?.session.user.roles?.map((r) => r.id))
  const { studentId } = useParams()
  const { isLoading: isLoadingUser, data: user } = useFetchData('auth/profile')

  const dispatch = useDispatch()
  const selected = useSelector((state) => state?.analytics?.analyticsCurriculum?.selected || null)
  const selectorState = useSelector(
    (state) => state?.analytics?.analyticsCurriculum?.selector || 'filter-by-student'
  )
  const byLoading = useSelector((state) => state?.analytics?.analyticsCurriculum?.byLoading || false)
  const marking = useSelector(
    (state) => state?.analytics?.analyticsCurriculum?.datasets?.data?.data?.marking || []
  )
  useEffect(() => {
    if (roles.some((role) => ['Parent', 'Student'].includes(role))) {
      dispatch(updateFieldValue('analyticsCurriculum', 'selector', 'filter-by-student'))
    } else if (roles.length === 1 && roles[0] === 'Teacher') {
      dispatch(updateFieldValue('analyticsCurriculum', 'selector', 'filter-by-classes'))
    } else {
      dispatch(updateFieldValue('analyticsCurriculum', 'selector', selectorState || 'filter-by-student'))
    }
  }, [])

  const setStudentSelected = (value) => {
    dispatch(updateFieldValue('analyticsCurriculum', 'selected', value))
  }

  const loadStudent = useCallback(async () => {
    if (isEmpty(selected) && user) {
      if (user.roles.some((role) => role.id === 'Student')) {
        setStudentSelected({
          ...user,
          _id: user._id || user.userId,
          studentId: user.userId
        })
      }

      if (user.roles.some((role) => role.id === 'Parent')) {
        if (user.children?.length > 0) {
          const student = user.children.find((child) => child._id === studentId)
          if (student) {
            setStudentSelected(student)
          }
        }
      }
    }
  }, [user, selected])

  useEffect(() => {
    loadStudent()
  }, [loadStudent])
  return (
    <>
      <Module.BodyHeader
        gap={2}
        className='border-b border-b-2 border-primary flex justify-start items-center relative'
        py={2}
      >
        <ViewSelector
          isLoading={isLoading || byLoading}
          value={selectorState}
          onChange={(value) => {
            dispatch(updateFieldValue('analyticsCurriculum', 'selector', value))
            dispatch(updateFieldValue('analyticsCurriculum', 'selected', null))
            dispatch(updateFieldValue('analyticsCurriculum', 'byStudent', []))
            dispatch(updateFieldValue('analyticsCurriculum', 'byClasses', []))
          }}
        />
        <div
          className='flex justify-start items-center absolute top-0px bottom-0px right-0'
          style={{
            left: roles.some((role) => ['Parent', 'Student'].includes(role)) ? '0' : 'calc(150px + 2rem)'
          }}
        >
          <SelectorStudentClass
            type={selectorState === 'filter-by-student' ? 'analyticsUsers' : 'analyticsClasses'}
            onChange={setStudentSelected}
            isLoading={byLoading || isLoading}
            selected={selected}
            selectorState={selectorState}
          />
        </div>
      </Module.BodyHeader>
      <Module.BodyContainer classNameWrapper='overflow-auto relative' px={0} py={0}>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <Box className='px-2 py-2 sticky top-0px inset-x-0 h-6 bg-background flex items-center justify-start gap-4 z-10 border-b border-b-2 border-primary'>
              <MarkignLegend marking={marking} />
            </Box>
            {selectorState === 'filter-by-student' && <ByStudent isLoading={byLoading || isLoading} />}
            {selectorState === 'filter-by-classes' && <ByClasses isLoading={byLoading || isLoading} />}
          </>
        )}
      </Module.BodyContainer>
    </>
  )
}

export default Current
